<script>
   /*************************************************************/
   /* Svelte component for showing NIMCA model table            */
   /*************************************************************/


   // main properties of the whole app
   let {nimca, isAlt = false} = $props();
</script>


{#if nimca}
<table>
   <thead>
   <tr>
      <th></th>
      <th>f</th>
   </tr>
   </thead>
   <tbody>
   <tr>
      <td class="label">DoF (Nf)</td>
      <td>{nimca.Nf}</td>
   </tr>
   <tr>
      <td class="label">Mean (f0)</td>
      <td>{nimca.f0.toFixed(3)}</td>
   </tr>
   <tr>
      <td class="label">Crit (extreme)</td>
      <td>{nimca.eCrit.toFixed(1)}</td>
   </tr>
   {#if !isAlt}
   <tr>
      <td class="label">Crit (outliers)</td>
      <td>{nimca.oCrit.toFixed(1)}</td>
   </tr>
   {/if}
   </tbody>
</table>
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }

   .label {
      text-align: left;
      padding: 0.1em 0.5em;
   }
</style>